// 明细只展示本笔历史快照，缺失金额不以当前钱包余额或零代替。
const money = value => value !== null && value !== undefined && /^\d+(?:\.\d+)?$/.test(String(value)) ? `${value} 元` : '—';
const text = value => value === null || value === undefined || value === '' ? '—' : String(value);
export function treasureRecordTime(value) {
  if (!value) return '—';
  if (typeof value === 'string' && !/^\d+$/.test(value)) return value;
  const date = new Date(Number(value) * (Number(value) < 1e12 ? 1000 : 1));
  return Number.isFinite(date.getTime()) ? date.toLocaleString('zh-CN', { hour12: false }) : '—';
}
export function treasureRecordDetails(kind, item) {
  if (!item) return [];
  if (kind === 'interest') return [
    ['计息订单号', text(item.orderNo)], ['计息日期', text(item.interestDate)],
    ['计息本金', money(item.principalAmount)], ['计息年利率', item.annualInterestRate == null ? '—' : `${item.annualInterestRate}%`],
    ['收益金额', money(item.interestAmount)], ['状态', item.claimable === true ? '可领取' : ({1:'处理中',2:'已到账',3:'已过期',4:'领取失败',5:'累计中',6:'已结转'}[item.status] || '状态待确认')],
    ['到账时间', treasureRecordTime(item.claimedAt)], ['累计未派发', money(item.accumulatingAmount)]
  ];
  if (kind === 'transfer') return [
    ['转账流水号', text(item.transferNo)],
    ['转出钱包', ({IN:'中心钱包',OUT:'余额宝钱包'})[item.direction] || '—'],
    ['转入钱包', ({IN:'余额宝钱包',OUT:'中心钱包'})[item.direction] || '—'],
    ['转账金额', money(item.amount)], ['转账时间', treasureRecordTime(item.transferredAt)],
    ['转账后中心钱包余额', money(item.centerBalanceAfter)], ['转账后余额宝本金', money(item.treasureBalanceAfter)]
  ];
  return [
    ['任务订单号', text(item.orderNo)], ['任务名称', text(item.taskName)],
    ['参与场馆', item.venueNames?.length ? item.venueNames.join('、') : item.venueName || (item.taskMode === 1 ? '全部场馆' : '—')],
    ['参与金额', money(item.participationAmount)], ['要求有效流水', money(item.requiredTurnover)],
    ['已完成有效流水', money(item.validTurnoverAmount ?? item.completedTurnover)], ['奖励金额', money(item.rewardAmount)],
    ['状态', text(item.statusName)], ['接取时间', treasureRecordTime(item.appliedAt)], ['完成时间', treasureRecordTime(item.completedAt)],
    ['奖励解锁时间', treasureRecordTime(item.unlockedAt || item.unlocksAt)], ['奖励领取截止', treasureRecordTime(item.expiresAt || item.claimValidUntil)]
  ];
}
